import { render, staticRenderFns } from "./DashboardBudgetPermissionV2.vue?vue&type=template&id=7c031f34&"
import script from "./DashboardBudgetPermissionV2.vue?vue&type=script&lang=js&"
export * from "./DashboardBudgetPermissionV2.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBudgetPermissionV2.vue?vue&type=style&index=0&id=7c031f34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports